// extracted by css-extract-rspack-plugin
var _1 = "LXwEjpane2gyvNyI";
var _2 = "buRG2BGzGI0K8h9G";
var _3 = "oL2TlDzse78Ii_zF";
var _4 = "h0fN7FS95uApQIeb";
var _5 = "gZeWIXoonEgj_Yjq";
var _6 = "_inzqpuPuHwNyaSE";
export { _1 as "simpleSliderArrowWrapper", _2 as "simpleSliderArrowWrapperLeft", _3 as "simpleSliderArrowWrapperRight", _4 as "simpleSliderContainer", _5 as "simpleSliderSlide", _6 as "simpleSliderWrapper" }
// extracted by css-extract-rspack-plugin
var _1 = "LXwEjpane2gyvNyI";
var _2 = "buRG2BGzGI0K8h9G";
var _3 = "oL2TlDzse78Ii_zF";
var _4 = "h0fN7FS95uApQIeb";
var _5 = "gZeWIXoonEgj_Yjq";
var _6 = "_inzqpuPuHwNyaSE";
export { _1 as "simpleSliderArrowWrapper", _2 as "simpleSliderArrowWrapperLeft", _3 as "simpleSliderArrowWrapperRight", _4 as "simpleSliderContainer", _5 as "simpleSliderSlide", _6 as "simpleSliderWrapper" }
